module.exports = __webpack_public_path__ + "assets/img/fashion-img1-7c6a91eb.png";